import React, {Component} from "react";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import SimpleDDL from "../../../modules/SimpleDDL";
import Container from "../../../modules/commons/Container";
import Api from "../../../Services/Api";
import {mapToObjectDDL} from "../../common/mapper";
import BeforeSubmission from "./beforeSubmission/beforeSubmission";
import OnSubmission from "./onSubmission/onSubmission";
import OnSamsatAcceptance from "./onSamsatAcceptance/onSamsatAcceptance";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class ProsesSamsat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dataCabang: [],
            rawDataCabang: [],
            search: {
                kodeCabang: null,
            },
            tabIndex: 0,
        }
    }

    componentDidMount() {
        this.fetchDataCabang();
    }

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            search: {
                ...prevValue.search,
                [name]: value,
            }
        }));
    };

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                        ...prevValue,
                        rawDataCabang: filteredData,
                        dataCabang: filteredData.map(data => mapToObjectDDL(data.namaDealer, data.kodeCabang)),
                        search: {
                            ...prevValue.search,
                            kodeCabang: mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang),
                        },
                    }));
                }
            }
        } catch (error) {
            console.log("errors: ", error);
        }
    }

    handleChangeTab = (tabIndex) => {
        this.setState((prevValue) => ({
            ...prevValue,
            tabIndex: tabIndex,
        }))
    };

    render() {
        return (
            <Container>
                <SimpleDDL
                    id="select_options_nama_cabang"
                    box="search"
                    name="kodeCabang"
                    containerclassname="width width-250px"
                    placeholder="Nama Cabang"
                    menuPosition="fixed"
                    options={this.state.dataCabang}
                    value={this.state.search.kodeCabang}
                    onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                />
                <Tabs selectedIndex={this.state.tabIndex} onSelect={this.handleChangeTab}>
                    <TabList>
                        <Tab id="button_navigate_before_submission_samsat">Belum Pengajuan SAMSAT</Tab>
                        <Tab id="button_navigate_on_submission">Pengajuan SAMSAT</Tab>
                        <Tab id="button_navigate_on_samsat_acceptance">Penerimaan SAMSAT</Tab>
                    </TabList>
                    <TabPanel>
                        <BeforeSubmission {...this.props} selectedCabang={this.state.search.kodeCabang}
                                          tabIndex={this.state.tabIndex}/>
                    </TabPanel>
                    <TabPanel>
                        <OnSubmission {...this.props} rawDataCabang={this.state.rawDataCabang}
                                      selectedCabang={this.state.search.kodeCabang}
                                      tabIndex={this.state.tabIndex}/>
                    </TabPanel>
                    <TabPanel>
                        <OnSamsatAcceptance {...this.props} selectedCabang={this.state.search.kodeCabang}
                                            tabIndex={this.state.tabIndex}/>
                    </TabPanel>
                </Tabs>
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProsesSamsat);
